export const PRELOADING = 'src/components/UI/Preloader/Preloading';
export const Preloading = (isPreloading) => {
    return {
        type: PRELOADING,
        isPreloading
    }
};